var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001317",
    d: "M6 4.2 9.9.3a.95.95 0 0 1 .7-.275q.426 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L6.7 6.3q-.3.3-.7.3a.96.96 0 0 1-.7-.3L.7 1.7A.95.95 0 0 1 .425 1Q.425.575.7.3a.95.95 0 0 1 .7-.275q.426 0 .7.275z"
  })));
};
export default SvgArrowDown;